import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind classes deduplicating conflicts. Standard shadcn/ui
 * utility — `clsx` builds the conditional class string, then
 * `tailwind-merge` resolves things like `px-2 px-4` → `px-4` so
 * caller-overridden classes win cleanly.
 *
 * Used by every shadcn primitive in `src/components/ui/`.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
